<template>
  <v-card text elevation=0>
    <v-card-text>
      <v-layout>
        <v-flex class="text-xs-center">
          <v-progress-circular
            :rotate="-90"
            :size="100"
            :width="20"
            :value="Math.round(usage * 100)"
            :color="color"
          >
            <div class="text-xs-center">
              {{ Math.round(usage * 100) }} % Used
            </div>
          </v-progress-circular>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions class="subtitle-2">
      {{name}}:
      <v-spacer></v-spacer>
      {{used}} / {{available}}
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    props: {
      usage: Number,
      used: Number,
      available: Number,
      name: String,
      color: String
    },
    data: () => ({
    }),
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// UsageCircularBox.vue?303318c1